import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Assessment } from "../../../enums/Assessment";
import {Typography} from "@mui/material";

const assessmentLabels = {
    [Assessment.VALID]: 'Gültig',
    [Assessment.UNFAIR]: 'Unfair',
    [Assessment.VOID]: 'Unwirksam'
};

const assessmentText = {
    [Assessment.VALID]: 'gültig',
    [Assessment.UNFAIR]: 'unfair',
    [Assessment.VOID]: 'unwirksam'
};

const assessmentOrder = [Assessment.VALID, Assessment.UNFAIR, Assessment.VOID];

const ConfusionMatrix = ({ matrix, total }) => {
    if (!matrix) {
        return <></>;
    }

    const chartData = assessmentOrder.map(trueLabel => {
        const rowTotal = assessmentOrder.reduce((sum, predictedLabel) => sum + matrix[trueLabel][predictedLabel], 0);

        return {
            name: assessmentLabels[trueLabel],
            data: assessmentOrder.map(predictedLabel => ({
                x: assessmentLabels[predictedLabel],
                y: rowTotal === 0 ? 0 : matrix[trueLabel][predictedLabel] / rowTotal,
                count: matrix[trueLabel][predictedLabel],
                trueLabel,
                predictedLabel,
                rowTotal
            }))
        };
    }).reverse();

    return (
        <div>
            <h2>Konfusionsmatrix</h2>
            <p>Die Spalten zeigen die KI-Bewertung, die Zeilen die Bewertung der Anwälte. Die Werte sind zeilenweise normalisiert.</p>
            {total > 0 ?
                <ReactApexChart options={{
                    colors: ["#008FFB"],
                    dataLabels: {
                        enabled: true,
                        formatter: (val) => `${(val * 100).toFixed(2)}%`,
                        style: {
                            colors: ['#000'],
                        },
                    },
                    xaxis: {
                        title: {
                            text: 'KI-Bewertung',
                        },
                    },
                    yaxis: {
                        title: {
                            text: 'Anwaltsbewertung',
                        },
                    },
                    tooltip: {
                        custom: ({ seriesIndex, dataPointIndex, w }) => {
                                const point = w.config.series[seriesIndex].data[dataPointIndex];
                                const percentage = (point.y * 100).toFixed(2);
                                const interpretation = point.trueLabel === point.predictedLabel
                                    ? `Die KI hat diese Klauseln korrekt als ${assessmentText[point.predictedLabel]} bewertet.`
                                    : `Die KI hat diese Klauseln als ${assessmentText[point.predictedLabel]} bewertet, tatsächlich waren sie aber ${assessmentText[point.trueLabel]}.`;

                                return `
                                    <div style="padding: 10px; max-width: 320px;">
                                        <strong>${percentage}% (${point.count} von ${point.rowTotal})</strong>
                                        <div style="margin-top: 6px; white-space: normal;">${interpretation}</div>
                                    </div>
                                `;
                        },
                    },
                }} series={chartData} type="heatmap" height={350} /> : <Typography>Nicht genug Daten mit Anwaltsbewertung vorhanden.</Typography>
            }
        </div>
    );
};

export default ConfusionMatrix;
